export default __webpack_public_path__ + "static/media/eye.8952ceb4.png";